import { DisplayOption, MediaItem } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { Img } from '@shared/Frontend/components/img'
import { Video } from '@shared/Frontend/components/video'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import React from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'

export const MediaBlock: BlocksView['MediaBlock'] = (props) => {
  const { id, items } = props
  if (items?.length == 0) return <></>
  const { inView, ref } = useInView({ threshold: 0.1 })
  return (
    <section id={id} ref={ref} className={cn('block block--media ls-spacing', inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter gridsys--columns">
        <BlockHeader {...props} headerClassName='gridsys--50p' />

        <div className="block__content gridsys--50p">
          <ListLayout
            {...props}
            itemClassName={(displayOption) =>
              cn('block__figure')
            }
            imageSize={(!props.label && !props.title && !props.introduction) ? 'large' : 'narrow' }
          />

          <BlockActions {...props} datalayerCategory="media_block" />
        </div>
      </div>
    </section>
  )
}

export const ListLayout = (props: {
  items: (MediaItem & { displayOption: DisplayOption })[]
  videoCookieAccepted: boolean
  acceptVideoCookie: () => void
  itemClassName?: string | ((displayOption: DisplayOption) => string)
  imageSize: 'large' | 'narrow'
}) => {
  return props.items.map((item, index) => <ItemLayout key={`media-${index}`} {...item} videoCookieAccepted={props.videoCookieAccepted} acceptVideoCookie={props.acceptVideoCookie} itemClassName={props.itemClassName} imageSize={props.imageSize} />)
}

export const ItemLayout = (
  props: {
    videoCookieAccepted: boolean
    acceptVideoCookie: () => void
    itemClassName?: string | ((displayOption: DisplayOption) => string)
    imageSize: 'large' | 'narrow'
  } & MediaItem & { displayOption: DisplayOption }
) => {
  const { acceptVideoCookie, videoCookieAccepted, itemClassName, displayOption, kind, caption, source } = props
  const itemClass = itemClassName
    ? typeof itemClassName == 'string'
      ? itemClassName
      : itemClassName(displayOption)
    : ''
  const { inView, ref } = useInView({ threshold: 0.2 })
  return (
    <figure
      ref={ref}
      className={cn(
        `figure--${displayOption == 'content-width' ? 'cw' : 'fw'} figure--${kind}`,
        itemClass,
        inView && 'inview'
      )}
    >
      {props.kind == 'image' ? (
        <Img
          {...props.image}
          loading="lazy"
          className="figure__image"
          // 16:9 to reserve some space
          width={displayOption == 'content-width' ? '592' : '1216'}
          height={displayOption == 'content-width' ? '333' : '684'}
          sizes={displayOption == 'content-width'
              ? props.imageSize == 'large'
                ? '(min-width: 1440px) 768px, (min-width: 1024px) 45w, 90vw'
                : '(min-width: 1440px) 592px, (min-width: 1024px) 45w, 90vw'
              : '(min-width: 1440px) 1216px, 90vw'
          }
        />
      ) : (
        props.kind == 'video' && (
          <Video
            url={props.url}
            videoCookieAccepted={videoCookieAccepted}
            acceptVideoCookie={acceptVideoCookie}
          />
        )
      )}

      {(caption || source) && (
        <figcaption className="figure__figcaption">
          {caption && <span className="figure__caption text--md">{caption} {source && <cite className="figure__source text--sm">({source})</cite>}</span>}
          {!caption && source && <cite className="figure__source text--md">{source}</cite>}
        </figcaption>
      )}
    </figure>
  )
}
